// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Form__Label = require("../../uikit/reason/atoms/Form/Form__Label.bs.js");
let ReactRender = require("../../reason/utils/ReactRender.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let AutocompleteV5 = require("../autocomplete/AutocompleteV5.bs.js");
let Form__HelpLabel = require("../../uikit/reason/atoms/Form/Form__HelpLabel.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let TMPUIKIT____CssGrid__Jsx3 = require("../../temporaryUIKit/TMPUIKIT___CssGrid/TMPUIKIT____CssGrid__Jsx3.bs.js");

function getOptionLabel(param) {
  return param.name;
}

function getOptionValue(param) {
  return param.id;
}

let Option = {
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue
};

function DisplayNeighborhoodInputRelay(props) {
  let status = props.status;
  return JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
    width: 12,
    children: [
      JsxRuntime.jsx(Form__Label.make, {
        labelText: "Display neighborhood",
        optionalText: "optional"
      }),
      ReactRender.fromOption(props.helpText, text => JsxRuntime.jsx(Form__HelpLabel.make, {
        children: text
      })),
      JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
        getOptionLabel: getOptionLabel,
        getOptionValue: getOptionValue,
        isClearable: true,
        isDisabled: props.isDisabled,
        onBlur: props.onBlur,
        onChange: props.onChange,
        options: props.areas,
        placeholder: Stdlib_Option.getOr(props.placeholder, "Select a neighborhood"),
        value: props.value,
        status: status !== undefined ? (
            status === "ok" ? "Success" : "Failure"
          ) : "Neutral"
      })
    ]
  });
}

let make = DisplayNeighborhoodInputRelay;

exports.Option = Option;
exports.make = make;
/* Form__Label Not a pure module */
